import { FC, useRef, useState } from "react";
import {
  InputGroup,
  Input,
  InputRightElement,
  Button,
  Icon,
  Box,
  //   List,
  //   ListItem,
  //   useColorMode,
  //   useOutsideClick,
  InputProps,
} from "@chakra-ui/react";
import { FaSearch, FaTimes } from "react-icons/fa";

interface Props extends InputProps {
  onSearch: (value: string) => void;
  onResetSearch?: () => void;
  instantSearch?: boolean;
  onClickOptions?: (value: string) => void;
}

const SearchInput: FC<Props> = ({
  onSearch,
  instantSearch = false,
  onResetSearch = () => {},
  onClickOptions = () => {},
  ...props
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [value, setValue] = useState<string>("");
  const searchRef = useRef<HTMLInputElement>(null);
  //   const { colorMode } = useColorMode();
  //   const [showOptions, setShowOptions] = useState(false);
  //   useOutsideClick({
  //     ref: containerRef,
  //     handler: () => setShowOptions(false),
  //   });

  const resetSearch = () => {
    if (value.length > 2) {
      onSearch("");
    }
    setValue("");
    onResetSearch();
    if (searchRef.current) {
      searchRef.current.blur();
    }
  };

  return (
    <Box w="100%" position="relative" ref={containerRef}>
      <InputGroup>
        <Input
          ref={searchRef}
          onChange={(e) => {
            setValue(e.target.value);
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter" || instantSearch) {
              onSearch(value);
            }

            if (e.key === "Escape") resetSearch();
          }}
          //   onFocus={() => {
          //     setShowOptions(true);
          //   }}
          id="search"
          name="search"
          placeholder="Type and enter to search..."
          value={value}
          autoComplete="off"
          {...props}
        />
        <InputRightElement width="3rem">
          <Button
            variant="ghost"
            h="1.75rem"
            size="sm"
            onClick={() => {
              if (value) resetSearch();
            }}
            _hover={{ outline: "none" }}
            _focus={{ outline: "none" }}
          >
            <Icon as={value !== "" ? FaTimes : FaSearch} />
          </Button>
        </InputRightElement>
      </InputGroup>
    </Box>
  );
};

export default SearchInput;
